import { getEnvVar } from '@nucleus/lib-environment';
import { safeToArray } from '@nucleus/lib-shape';

export const Stage = getEnvVar('STAGE', 'development');

export const NameGeneratorFactory =
  (service: string) =>
  (parts: Array<string> | string): string =>
    '/' + [Stage, service, ...safeToArray(parts)].join('/');
